var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(-288 -2075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 40,
    height: 40,
    transform: "translate(288 2075)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_24-hours_2_",
    "data-name": "24-hours (2)",
    transform: "translate(292.774 2079.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M271.892,186.355h2.676v2.676a.892.892,0,1,0,1.784,0v-7.137a.892.892,0,1,0-1.784,0v2.676h-1.784v-2.676a.892.892,0,0,0-1.784,0v3.568A.892.892,0,0,0,271.892,186.355Z",
    transform: "translate(-254.882 -170.237)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M275.3,2.828a.892.892,0,1,0,.693-1.644A15.386,15.386,0,0,0,272,.006a.892.892,0,1,0-.221,1.771A13.741,13.741,0,0,1,275.3,2.828Z",
    transform: "translate(-254.881 0.001)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M390.224,53.122a.892.892,0,0,0,.171-1.25,15.248,15.248,0,0,0-2.917-2.917.892.892,0,1,0-1.079,1.421,13.463,13.463,0,0,1,2.576,2.576A.892.892,0,0,0,390.224,53.122Z",
    transform: "translate(-363.086 -45.872)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M463.981,147.435a.892.892,0,0,0-1.644.693,14.076,14.076,0,0,1,1.11,3.577.892.892,0,0,0,1.771-.221A15.7,15.7,0,0,0,463.981,147.435Z",
    transform: "translate(-434.773 -138.153)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M15.226,83.123A15.391,15.391,0,0,0,30.444,69.792a.892.892,0,1,0-1.771-.221A13.689,13.689,0,0,1,15.226,81.338,13.422,13.422,0,0,1,5.174,59v.376a.892.892,0,0,0,1.784,0V56.894A.892.892,0,0,0,6.066,56H3.5a.892.892,0,1,0,0,1.784h.37A15.2,15.2,0,0,0,15.226,83.123Z",
    transform: "translate(0 -52.671)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M149.126,2.828a13.736,13.736,0,0,1,3.517-1.051.892.892,0,1,0-.221-1.771,15.383,15.383,0,0,0-3.989,1.177.892.892,0,1,0,.693,1.644Z",
    transform: "translate(-139.092 0)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M75,85.767A10.765,10.765,0,1,0,85.765,75,10.8,10.8,0,0,0,75,85.767Zm10.765-8.981a8.981,8.981,0,1,1-8.981,8.981A8.991,8.991,0,0,1,85.765,76.786Z",
    transform: "translate(-70.539 -70.541)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M153.141,185.641c-.954.715-2.141,1.606-2.141,3.39a.892.892,0,0,0,.892.892h3.569a.892.892,0,0,0,0-1.784h-2.415a4.9,4.9,0,0,1,1.166-1.071c.954-.715,2.141-1.606,2.141-3.39a2.676,2.676,0,0,0-5.353,0,.892.892,0,1,0,1.784,0,.892.892,0,0,1,1.784,0C154.568,184.529,154.053,184.957,153.141,185.641Z",
    transform: "translate(-142.019 -170.237)",
    fill: "#4A4A4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customer-service.e41aa9d5fdc91726e5a4bf454457578d.svg";
export { ForwardRef as ReactComponent };